import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Scrollbar from "../../components/scrollbar";
import { FaPenSquare } from "react-icons/fa";
import { deletePromo } from "../../utils/apis/func";
import { toast } from "react-toastify";
import { Dialog, DialogBody, DialogHeader } from "@material-tailwind/react";
import { MdDeleteOutline } from "react-icons/md";
import { useAppDispatch } from "../../utils/redux/hooks";
import { addisLoading } from "../../utils/redux/mainSlice";

const PromoCode = () => {
  const [promoCodes, setPromoCodes] = useState<any[]>([]);
  const [services, setServices] = useState<Record<string, string>>({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [activePromo, setActivePromo] = useState(true);
  const itemsPerPage = 10;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const fetchServices = async () => {
    try {
      const AuthToken = await localStorage.getItem("AuthToken");
      const response = await axios.get(
        "https://api.pureworker.com/api/admin/services",
        {
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        }
      );
      if (response.status === 200 && response.data.status === "success") {
        const servicesData = response.data.data || [];
        const servicesMap: Record<string, string> = {};
        servicesData.forEach((service: any) => {
          servicesMap[service._id] = service.name;
        });
        setServices(servicesMap);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const fetchPromoCodes = async () => {
    try {
      const AuthToken = await localStorage.getItem("AuthToken");
      const response = await axios.get(
        `https://api.pureworker.com/api/admin/promos`,
        {
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        }
      );

      if (response.status === 200 && response.data.status === "success") {
        const promoData = response.data.data || [];
        setPromoCodes(promoData);
        setTotalRecords(response.data.totalRecords || promoData.length);
      }
    } catch (error) {
      console.error("Error fetching promo codes:", error);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  useEffect(() => {
    fetchPromoCodes();
  }, [currentPage, activePromo]);

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    if (currentPage < Math.ceil(totalRecords / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getServiceNames = (serviceIds: string[]) => {
    return serviceIds.map((id) => services[id] || id).join(", ");
  };

  // patches start here
  const allTabs = [
    {
      title: "All Promo Code",
      value: "all",
    },
    {
      title: "Active Promo Code",
      value: "active",
    },
    {
      title: "Inactive Promo COde",
      value: "expired",
    },
  ];

  const [activeTab, setActiveTab] = useState<string>(allTabs[0].value);

  const handleActive = (item: string) => {
    setActiveTab(item);
  };

  const activePromoCodes = promoCodes.filter((item) => item.active);
  const expiredPromoCodes = promoCodes.filter((item) => !item.active);

  const allPromoCodes =
    activeTab === "all"
      ? promoCodes
      : activeTab === "active"
      ? activePromoCodes
      : expiredPromoCodes;

  const [selectedPromoCode, setSeleteedPromoCode] = useState();
  const [openDelete, setDelete] = useState(false);

  const handleOpenDelete = () => {
    setDelete(!openDelete);
  };

  const handleDeletePromoCode = async (id: any) => {
    dispatch(addisLoading(true));

    try {
      const response = await deletePromo(id);
      if (
        response.status === 200 ||
        response.status === 201 ||
        response.status === 204
      ) {
        toast.success("Promo code deleted successfully!");
        handleOpenDelete();
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
      toast.error("AN error occured");
    } finally {
      dispatch(addisLoading(false));
    }
  };

  return (
    <>
      <div className="relative overflow-x-auto px-3">
        <h2 className="text-2xl font-bold text-black mb-4">Promo code</h2>

        <div className="mb-4 flex-col gap-4 md:flex-row flex justify-between">
          <div>
            {allTabs.map((item) => (
              <button
                onClick={() => handleActive(item.value)}
                className={`px-4 py-2 rounded-md ${
                  activeTab === item.value
                    ? "bg-[#88087B] text-white"
                    : "bg-gray-200"
                }`}
              >
                {item.title}
              </button>
            ))}
          </div>
          <button
            onClick={() => navigate("/promoCode/new")}
            className="ml-2 px-4 py-2 bg-[#88087B] text-white rounded-md"
          >
            New Promo code
          </button>
        </div>

        <div className="overflow-x-auto rounded-t-lg">
          <table className="text-sm text-gray-500 dark:text-gray-400 px-3 text-center w-full">
            <thead className="bg-[#88087B] py-8 px-10 text-[#F7F7F7] font-roboto text-sm lg:text-lg font-medium leading-normal rounded-t-lg whitespace-nowrap">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Code
                </th>
                <th scope="col" className="px-6 py-3">
                  Services
                </th>
                <th scope="col" className="px-6 py-3">
                  Discount (%)
                </th>
                <th scope="col" className="px-6 py-3">
                  Status
                </th>
                <th scope="col" className="px-6 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {allPromoCodes.length > 0 ? (
                allPromoCodes.map((promo) => (
                  <tr
                    key={promo._id}
                    className="py-4 px-20 hover:bg-[#87878d] text-black transition duration-300 font-roboto text-xs font-medium leading-normal items-center"
                  >
                    <td className="px-6 py-4">{promo.code}</td>
                    <td className="px-6 py-4">
                      {promo.applyToAllServices
                        ? "All Services"
                        : getServiceNames(promo.services)}
                    </td>
                    <td className="px-6 py-4">{promo.percentageDiscount}%</td>
                    <td className="px-6 py-4">
                      {promo.active ? "Active" : "Inactive"}
                    </td>
                    <td className="px-6 py-4">
                      {activePromo && (
                        <FaPenSquare
                          className="cursor-pointer text-black bg-transparent rounded-md"
                          onClick={() =>
                            navigate(`/promoCode/edit/${promo._id}`)
                          }
                        />
                      )}
                    </td>
                    <td className="px-6 py-4">
                      <MdDeleteOutline
                        onClick={() => {
                          setDelete(true);
                          setSeleteedPromoCode(promo?._id);
                        }}
                        size={25}
                        className=" cursor-pointer text-[#fff] bg-[#D11C1C] rounded-md p-0.5"
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="px-6 py-4">
                    No promo codes found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Scrollbar
          currentPage={currentPage}
          totalPages={Math.ceil(totalRecords / itemsPerPage)}
          itemsPerPage={itemsPerPage}
          totalItems={totalRecords}
          onPrevPageClick={handlePrevPageClick}
          onNextPageClick={handleNextPageClick}
        />
      </div>

      <Dialog open={openDelete} handler={handleOpenDelete}>
        <DialogHeader>Delete Agent</DialogHeader>
        <DialogBody>
          <div className="relative p-4 w-full  max-h-full flex  flex-col">
            <div className="p-4 md:p-5 text-center mx-auto ">
              <svg
                className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                Are you sure you want to delete Promo Code?
              </h3>
              <button
                data-modal-hide="popup-modal"
                type="button"
                className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center me-2"
                onClick={() => {
                  handleDeletePromoCode(selectedPromoCode);
                }}
              >
                Proceed
              </button>
              <button
                data-modal-hide="popup-modal"
                type="button"
                className="text-gray-500 ml-4 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                onClick={() => {
                  // close();
                  setDelete(false);
                }}
              >
                No, cancel
              </button>
              {/* {isLoading && (
                <>
                  <Dots size={40} color="var(--admin-accent)" />
                </>
              )} */}
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
};

export default PromoCode;
